import { jobHit } from '../../components/jobHit';
import { algoliaAppId, algoliaApiKey, jobsSearchIndex } from '../../variables';
import algoliasearch from 'algoliasearch/lite';

// eslint-disable-next-line no-undef
const object = vnJobObject;
const {
    city,
    jobTypeContract,
    jobBusinessSector,
    latlng,
    radius,
} = object.jobsQueryStrings;

// Initialisation d'Algolia
const client = algoliasearch(algoliaAppId, algoliaApiKey);
const index = client.initIndex(jobsSearchIndex);

// Récupérer tous les blocs .vn-block.jobs-block présents sur la page
document.querySelectorAll('.vn-block.jobs-block').forEach(block => {
    // Récupérer la valeur de data-algolia_query
    let algoliaQueryData = block.getAttribute('data-algolia_query');
    if(algoliaQueryData !== "[]") {
        try {
            // Parser le JSON pour obtenir les paramètres
            const queryParamsData = JSON.parse(algoliaQueryData);

            // Initialiser le filtre comme une chaîne vide
            let filters = '';

            // Job Trades
            if (queryParamsData.job_trades && queryParamsData.job_trades.length > 0) {
                const jobTradesFilter = queryParamsData.job_trades.map(trade => `"${trade}"`).join(' OR ');
                filters += `jobTrades.name:${jobTradesFilter}`;
            }

            // Job Type Contract
            if (queryParamsData.job_type_contract && queryParamsData.job_type_contract.length > 0) {
                const jobTypeContractFilter = queryParamsData.job_type_contract.map(type => `"${type}"`).join(' OR ');
                filters += filters ? ` AND jobTypeContract.name:${jobTypeContractFilter}` : `jobTypeContract.name:${jobTypeContractFilter}`;
            }

            // Job Business Sector
            if (queryParamsData.job_business_sector && queryParamsData.job_business_sector.length > 0) {
                const jobBusinessSectorFilter = queryParamsData.job_business_sector.map(sector => `"${sector}"`).join(' OR ');
                filters += filters ? ` AND jobBusinessSector.name:${jobBusinessSectorFilter}` : `jobBusinessSector.name:${jobBusinessSectorFilter}`;
            }
            console.log(filters);

            // Algolia request params
            const queryParams = {
                hitsPerPage: queryParamsData.number_jobs || 100, // default 100 jobs
                filters: filters ? filters : undefined,
            };

            // add geo query
            if (queryParamsData.lat_lng) {
                queryParams.aroundLatLng = queryParamsData.lat_lng; // must be "latitude,longitude"
            }

            if (queryParamsData.radius) {
                queryParams.aroundRadius = queryParamsData.radius; // Radius in meters
            }

            // Rechercher les jobs avec Algolia
            index.search('', queryParams).then(({ hits, nbHits }) => {
                // Boucle sur chaque résultat
                const container = block.querySelector('.jobs-block__container .grid');
                if (container) {
                    container.innerHTML = '';
                    hits.forEach(job => {
                        const jobElement = jobHit(job);
                        container.insertAdjacentHTML('beforeend', jobElement);
                    });

                    // see more button
                    let seeMoreContainer = block.querySelector('.jobs-block__view_more');
                    if (nbHits > hits.length) {
                        const button = document.createElement('a');
                        button.classList.add('vn-btn', 'vn-btn--blue');
                        button.textContent = object.seeMore;
                        button.href = generateSearchUrl(queryParamsData);
                        seeMoreContainer.appendChild(button);
                    } else {
                        seeMoreContainer.remove();
                    }
                }
            }).catch(err => {
                console.error('Error while searching Algolia:', err);
            });
        } catch (e) {
            console.error('Invalid JSON in data-algolia_query:', e);
        }
    }
});

function generateSearchUrl(queryParamsData) {
    // Construire l'URL de recherche avec les bons paramètres
    const baseUrl = object.jobSearchPageUrl.replace(/\/$/, ''); //remove last "/" on baseUrl
    let url = `${baseUrl}`;

    if (queryParamsData.radius) {
        url += `/${radius}/${encodeURIComponent(Math.round(queryParamsData.radius / 1000))}`;
    }
    if (queryParamsData.city) {
        url += `/${city}/${encodeURIComponent(queryParamsData.city)}`;
    }
    if (queryParamsData.lat_lng) {
        url += `/${latlng}/${encodeURIComponent(queryParamsData.lat_lng)}`;
    }
    if (queryParamsData.job_type_contract && queryParamsData.job_type_contract.length > 0) {
        url += `/${jobTypeContract}/${encodeURIComponent(queryParamsData.job_type_contract.join(','))}`;
    }
    if (queryParamsData.job_business_sector && queryParamsData.job_business_sector.length > 0) {
        url += `/${jobBusinessSector}/${encodeURIComponent(queryParamsData.job_business_sector.join(','))}`;
    }

    return url;
}
